
    <!--
 * 竖版-全局弹窗
 * @LastEditTime: Sat Sep 14 2024 18:08:17 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_EPKV20"  :class="[`normal`,`u_c_EPKV20`]" ><div id="u_c_I48K21"  v-show="compData.previewPopup == 'bind' || pageData.bindPopupState" :class="[`normal popup`,`u_c_I48K21`]" @click="u_c_I48K21_event_F8M123($event)"><div id="u_c_1OB822"  :class="[`normal popup-content-small`,`u_c_1OB822`]" @click="u_c_1OB822_event_2MZ224($event)"><div id="u_c_4UE223"  :class="[`normal popup-title popup-title-color`,`u_c_4UE223`]" >{{`${ langData.bindTitle }`}}</div><div id="u_c_YUHB25"  :class="[`normal`,`u_c_YUHB25`]" ><div id="u_c_CQKU26"  :class="[`normal select-item `,`u_c_CQKU26`]" ><select id="u_c_GZMD27"  v-model="pageData.serverItem" :class="[`normal select-item-select `,`u_c_GZMD27`]" ><option id="u_c_8QQF28" disabled="disabled" :value="defaultServerItem" :class="[`normal`,`u_c_8QQF28`]" >{{`${ langData.selectServer }`}}</option><optgroup id="u_c_ZIPQ30"  :label="langData.yourServer" :class="[`normal`,`u_c_ZIPQ30`]" ><option id="u_c_02BK31"  v-for="(sItem, sIndex) in pageData.recentServerList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_02BK31`]" >{{`${ sItem.sname }`}}</option></optgroup><optgroup id="u_c_D17Q33"  :label="langData.allServer" :class="[`normal`,`u_c_D17Q33`]" ><option id="u_c_1T3P34"  v-for="(sItem, sIndex) in pageData.serverList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_1T3P34`]" >{{`${ sItem.sname }`}}</option></optgroup></select></div><div id="u_c_EBOH36"  :class="[`normal select-item`,`u_c_EBOH36`]" ><select id="u_c_46K737"  v-model="pageData.roleIndex" :class="[`normal select-item-select `,`u_c_46K737`]" ><option id="u_c_ZXZE38"  v-for="(rItem, rIndex) in pageData.roleList" :key="rIndex" :value="rIndex" :class="[`normal`,`u_c_ZXZE38`]" >{{`${ rItem.roleName }`}}</option></select></div></div><a id="u_c_2UDV40" href="javascript:;" :class="[`normal sure`,`u_c_2UDV40`]" @click="u_c_2UDV40_event_QSVC19($event)">{{`${ langData.bindBtn }`}}</a><div id="u_c_EELD42"  v-html="langData.canNoReBind" v-show="!pageData.canReBind" :class="[`normal txt-size tips-color`,`u_c_EELD42`]" ></div><a id="u_c_IXTY43" href="javascript:;" :class="[`normal popup-close`,`u_c_IXTY43`]" @click="u_c_IXTY43_event_DMX517($event)"></a></div></div><div id="u_c_J40V44"  v-show="compData.previewPopup == 'bag' || pageData.bagPopupState" :class="[`normal popup`,`u_c_J40V44`]" @click="u_c_J40V44_event_F8M123($event)"><div id="u_c_G90Y45"  :class="[`normal popup-content-big`,`u_c_G90Y45`]" @click="u_c_G90Y45_event_2MZ224($event)"><div id="u_c_F3OS46"  :class="[`normal popup-title popup-title-color`,`u_c_F3OS46`]" >{{`${ langData.myPackage }`}}</div><div id="u_c_JBXQ48"  :class="[`normal border-color`,`u_c_JBXQ48`]" ><table id="u_c_J9YU49"  :class="[`normal`,`u_c_J9YU49`]" ><thead id="u_c_ZVJ350"  :class="[`normal`,`u_c_ZVJ350`]" ><td id="u_c_8WD951"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_8WD951`]" >{{`${ langData.packageTime }`}}</td><td id="u_c_ZT6B53"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_ZT6B53`]" >{{`${ langData.packageName }`}}</td></thead><tbody id="u_c_CW1R55"  :class="[`normal`,`u_c_CW1R55`]" ><tr id="u_c_6SM956"  v-for="(packItem, pI) in pageData.myPackageList" :key="pI" :class="[`normal border-color tr `,`u_c_6SM956`]" ><td id="u_c_DMOQ57"  :class="[`normal td border-color txt-size txt-color`,`u_c_DMOQ57`]" >{{`${ packItem.award_time }`}}</td><td id="u_c_DOWL59"  :class="[`normal td border-color txt-size txt-color`,`u_c_DOWL59`]" ><span id="u_c_7W3S60"  v-html="packItem.award_name || giftInfo[packItem.award_block] && giftInfo[packItem.award_block][+packItem.send_id - 1] && giftInfo[packItem.award_block][+packItem.send_id - 1].name || ''" :class="[`normal`,`u_c_7W3S60`]" ></span><span id="u_c_JC4161"  v-html="`${ langData.giftCode }：${ packItem.award_code }`" v-show="packItem.send_type == 'sendSerial'" :class="[`normal`,`u_c_JC4161`]" ></span><a id="u_c_YZRB62" href="javascript:;" v-show="packItem['send_type'] == 'sendCoupon'" :class="[`normal popup-title-color txt-size`,`u_c_YZRB62`]" @click="u_c_YZRB62_event_1JVM17($event)">{{`[${ langData.useBtn }]`}}</a><a id="u_c_8QYO64" href="javascript:;" v-show="packItem['send_type'] == 'sendSerial'" :class="[`normal txt-size popup-title-color`,`u_c_8QYO64`]" @click="u_c_8QYO64_event_QX7K17($event,packItem.award_code)">{{`[${ langData.copyAndGoExchange }]`}}</a></td></tr></tbody></table><div id="u_c_YHLR66"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_YHLR66`]" ></div></div><a id="u_c_GD8367" href="javascript:;" :class="[`normal popup-close`,`u_c_GD8367`]" @click="u_c_GD8367_event_DMX517($event)"></a></div></div><div id="u_c_JBXS68"  v-show="compData.previewPopup == 'tips' || pageData.tipsPopupState" :class="[`normal popup`,`u_c_JBXS68`]" @click="u_c_JBXS68_event_TETB35($event)"><div id="u_c_FLPV69"  :class="[`normal popup-content-small`,`u_c_FLPV69`]" @click="u_c_FLPV69_event_U82518($event)"><div id="u_c_8UMN70"  :class="[`normal popup-title-color popup-title`,`u_c_8UMN70`]" >{{`${ pageData.tips }`}}</div><a id="u_c_AMGH72" href="javascript:;" :class="[`normal sure`,`u_c_AMGH72`]" @click="u_c_AMGH72_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><a id="u_c_EVGO74" href="javascript:;" :class="[`normal popup-close`,`u_c_EVGO74`]" @click="u_c_EVGO74_event_DMX517($event)"></a></div></div><div id="u_c_DSXT75"  v-show="compData.previewPopup == 'previewGift' || pageData.seeGiftPopupState" :class="[`normal popup`,`u_c_DSXT75`]" @click="u_c_DSXT75_event_TETB35($event)"><div id="u_c_HPWW76"  :class="[`normal popup-content-small`,`u_c_HPWW76`]" @click="u_c_HPWW76_event_U82518($event)"><div id="u_c_ZKSL77"  :class="[`normal popup-title-color popup-title`,`u_c_ZKSL77`]" >{{`${ langData.checkGiftBtn }`}}</div><div id="u_c_Z9SF79"  :class="[`normal `,`u_c_Z9SF79`]" ><table id="u_c_HBYF80"  :class="[`normal`,`u_c_HBYF80`]" ><tbody id="u_c_98EV81"  :class="[`normal`,`u_c_98EV81`]" ><tr id="u_c_DJ6M82"  v-for="(seeItem, seeIndex) in pageData.seeGift" :key="seeIndex" :class="[`normal border-color  tr `,`u_c_DJ6M82`]" ><td id="u_c_4ON683"  :class="[`normal td border-color txt-size txt-color`,`u_c_4ON683`]" ><img id="u_c_5A9Y84"  :src="seeItem.pic" v-show="seeItem.pic" :class="[`normal`,`u_c_5A9Y84`]" /></td><td id="u_c_ISS685"  :class="[`normal td border-color txt-size txt-color`,`u_c_ISS685`]" ><div id="u_c_08ZY86"  v-html="seeItem.name" :class="[`normal`,`u_c_08ZY86`]" ></div></td></tr></tbody></table></div><a id="u_c_BRQF87" href="javascript:;" :class="[`normal popup-close`,`u_c_BRQF87`]" @click="u_c_BRQF87_event_DMX517($event)"></a></div></div><div id="u_c_EHPW88"  v-show="compData.previewPopup == 'daoju' || pageData.propsPopupState" :class="[`normal popup`,`u_c_EHPW88`]" @click="u_c_EHPW88_event_TETB35($event)"><div id="u_c_IOX689"  :class="[`normal popup-content-big`,`u_c_IOX689`]" @click="u_c_IOX689_event_U82518($event)"><div id="u_c_83CB90"  :class="[`normal popup-title popup-title-color`,`u_c_83CB90`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_0RUO92"  :class="[`normal`,`u_c_0RUO92`]" ><div id="u_c_22F993"  :class="[`normal`,`u_c_22F993`]" ><div id="u_c_YMZE94"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_YMZE94`]" ></div></div><img id="u_c_22A595"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_22A595`]" /></div><a id="u_c_6OXR96" href="javascript:;" :class="[`normal sure`,`u_c_6OXR96`]" @click="u_c_6OXR96_event_YU9U68($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_IGPN98"  v-html="langData.daojuTips" :class="[`normal tips-color txt-size`,`u_c_IGPN98`]" ></div><a id="u_c_EM2I99" href="javascript:;" :class="[`normal popup-close`,`u_c_EM2I99`]" @click="u_c_EM2I99_event_DMX517($event)"></a></div></div><div id="u_c_5R8F100"  v-show="compData.previewPopup == 'youhuiquan' || pageData.quanPopupState" :class="[`normal popup`,`u_c_5R8F100`]" @click="u_c_5R8F100_event_TETB35($event)"><div id="u_c_2BKH101"  :class="[`normal popup-content-big`,`u_c_2BKH101`]" @click="u_c_2BKH101_event_U82518($event)"><div id="u_c_E8TO102"  :class="[`normal popup-title popup-title-color`,`u_c_E8TO102`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_C672104"  :class="[`normal`,`u_c_C672104`]" ><div id="u_c_1MD4105"  :class="[`normal`,`u_c_1MD4105`]" ><div id="u_c_H54V106"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_H54V106`]" ></div></div><img id="u_c_3NFV107"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_3NFV107`]" /></div><a id="u_c_BTH6108" href="javascript:;" :class="[`normal  sure`,`u_c_BTH6108`]" @click="u_c_BTH6108_event_35V252($event)">{{`${ langData.useBtn }`}}</a><a id="u_c_9BQD110" href="javascript:;" :class="[`normal popup-close`,`u_c_9BQD110`]" @click="u_c_9BQD110_event_DMX517($event)"></a></div></div><div id="u_c_2XPV111"  v-show="compData.previewPopup == 'xuhao' || pageData.giftCodePopupState" :class="[`normal popup`,`u_c_2XPV111`]" @click="u_c_2XPV111_event_TXZS38($event)"><div id="u_c_DB6Y112"  :class="[`normal popup-content-small`,`u_c_DB6Y112`]" @click="u_c_DB6Y112_event_EKU139($event)"><div id="u_c_7UKR113"  :class="[`normal popup-title popup-title-color`,`u_c_7UKR113`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_Z6D0115"  :class="[`normal`,`u_c_Z6D0115`]" ><div id="u_c_2BKA116"  :class="[`normal txt-size txt-color`,`u_c_2BKA116`]" >{{`${ langData.giftCode }：${ pageData.curGiftName }`}}</div><a id="u_c_XYF6118" href="javascript:;" :class="[`normal txt-size popup-title-color`,`u_c_XYF6118`]" @click="u_c_XYF6118_event_QX7K17($event)">{{`[${ langData.copy }]`}}</a></div><div id="u_c_B9NJ120" href="javascript:;" :class="[`${ compData.copyTipsState ? '' : 'hide' }`,`normal txt-size txt-color`,`u_c_B9NJ120`]" >{{`${ langData.copySucc }`}}</div><a id="u_c_BSRV122" href="javascript:;" :class="[`normal popup-close`,`u_c_BSRV122`]" @click="u_c_BSRV122_event_KBHJ41($event)"></a><a id="u_c_F9TM123" href="javascript:;" :class="[`normal sure`,`u_c_F9TM123`]" @click="u_c_F9TM123_event_YU9U68($event)">{{`${ langData.gotoExchange }`}}</a></div></div><div id="u_c_GAB2125"  v-show="compData.previewPopup == 'info' || pageData.infoPopupState" :class="[`normal popup`,`u_c_GAB2125`]" @click="u_c_GAB2125_event_TETB35($event)"><div id="u_c_2FB6126"  :class="[`normal popup-content-big`,`u_c_2FB6126`]" @click="u_c_2FB6126_event_U82518($event)"><div id="u_c_37SC127"  :class="[`normal popup-title popup-title-color`,`u_c_37SC127`]" >{{`${ langData.infoBtn }`}}</div><div id="u_c_1KND129"  v-html="compData.infoContent" :class="[`normal txt-size txt-color`,`u_c_1KND129`]" ></div><a id="u_c_FFZT130" href="javascript:;" :class="[`normal popup-close`,`u_c_FFZT130`]" @click="u_c_FFZT130_event_DMX517($event)"></a></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import useClipboard from "vue-clipboard3"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"infoContent":`1.活动介绍
（1）【成神归来 每日赠礼】
①活动期间，每日通过官网储值任意金额，即可领取首充奖励；
②当日首充奖励需在当日领取完毕，逾期失效，不可补领；

（2）【九考特训 签到送好礼】
①活动期间，每日登入活动页面，即可完成签到，累计签到天数达到1、3、7、12、14天后，即可领取签到奖励；
②每个档位的奖励，每个账号只能领取一次；
③未领取的奖励可在活动结束后7天内继续领取，7天后失效；


（3）【天使的选择】
①活动期间，通过官网储值日储值满5美金，每日可获得3次机会开启盲盒
②消耗一张抽奖券可以进行对应次数开盲盒，随机获得奖池内奖励
③抽奖券不会进行每天重置，需要在活动期间内进行使用，逾期无效。

（4）【成神祝福赠礼】
①活动期间，在【天使盲盒 】中累计消耗的抽奖券达到一定的数量，可以解锁领取对应的奖励；
②累计消耗数量针对整个活动期间进行统计，不会进行每天重置；
③未领取的奖励可在活动结束后7天内继续领取，7天后失效；


2.奖励发放
奖励将会直接发放至游戏内邮件处，可通过游戏内邮件查收

3.活动最终解释权归《斗罗大陆3D：魂师对决》运营团队所有。`,"copyTipsState":false,"previewPopup":``},"zh-TW":{"infoContent":`超值首儲贈好禮
活動期間，通過【官網儲值頁面】任意管道成功儲值任意金額，即可領取獎勵，每個帳號只能領取一次；
未領取的獎勵可在活動結束後7天內繼續領取，7天後失效；

每日簽到送不停
活動期間，每日登入活動頁面，即可完成簽到，累計簽到天數達到1、3、5、7天後，即可領取簽到獎勵；
每個檔位的獎勵，每個帳號只能領取一次；
未領取的獎勵可在活動結束後7天內繼續領取，7天后失效；
中秋賞月禮包
活動期間，通過【官網儲值頁面】任意管道儲值，每天累計儲值金額每次達到100TWD，都會獲得一張抽獎券；
消耗一張抽獎券可以進行一次抽獎，隨機獲得獎池內獎勵；
單日獲得抽獎券上限1000張；
抽獎券不會進行每天重置，需要在活動期間內進行使用，逾期無效;
二重好禮
活動期間，累計消耗的抽獎券達到一定的數量，可以解鎖領取對應的獎勵；
未領取的獎勵可在活動結束後7天內繼續領取，7天后失效；`,"copyTipsState":false,"previewPopup":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-TW']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();

    // 自定义setup - 开始
    const {
  toClipboard
} = useClipboard();

const showTips = inject("showTips", (txt, code) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const isIosAppWebview = window?.webkit?.messageHandlers?.callSDKMethodWithParameters;

const defaultServerItem = [
  {
    sid: "",
    id: "",
    sname: ""
  },
]
const defaultRoleItem = [{
  roleID: "",
  roleName: getLangTxt("selectRole")
}]
const curPlatform = pagePlatform;

const init = () => {
  compData.bindPopupState = false
  compData.bagPopupState = false
  compData.infoPopupState = false
  compData.tipsPopupState = false
  compData.propsPopupState = false
  compData.quanPopupState = false
  compData.seeGiftPopupState = false
  compData.giftCodePopupState = false
  compData.previewPopup = "";

  pageData.serverList = _.cloneDeep(defaultServerItem)
  pageData.roleList = _.cloneDeep(defaultRoleItem)

}

init()

watch(
  () => pageData.isLogin,
  async (value) => {
    if (!value) return
    await initServerList()
    initLinkServer()
  }
)

watch(
  () => pageData.serverItem,
  async (value) => {
    if (!value || !value.sid) return
    await initRoleList()
    initLinkRole()
  }
)

const initServerList = async () => {
  pageData.serverList = []
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'listServerNew'))
  if (res.result == 1) {
    res?.data?.all_servers ?
      pageData.serverList.push(...res.data.all_servers) :
      "";
    res?.data?.recent_servers ?
      pageData.recentServerList.push(...res.data.recent_servers) :
      "";
  }
}

const initRoleList = async () => {
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'getMobileGameRole'), {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
    }),
  })
  if (res.result == 1) {
    pageData.roleList.push(...res.data)
    if (res.data.length == 1) {
      pageData.roleIndex = 1
    }
  }
}

const initLinkServer = () => {
  let linkParam =
    utils.getUrlParams("serverId") ||
    utils.getUrlParams("server_id") ||
    utils.getUrlParams("serverID")
  let _index = 0
  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.serverItem = pageData.serverList[_index];
  }
}

const initLinkRole = () => {
  let linkParam =
    utils.getUrlParams("roleId") || utils.getUrlParams("roleID")
  let _index = 0
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.roleIndex = _index
  }
}

const canClickBindSubmit = ref(true)
const bindRole = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'bind'), {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
      server_sid: pageData.serverItem.id,
      role_id: pageData.roleList[pageData.roleIndex].roleID,
      role_name: encodeURIComponent(
        encodeURIComponent(pageData.roleList[pageData.roleIndex].roleName)
      ),
      server_name: pageData.serverItem.sname,
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.serverName = res.data.bind_data.server_name
    pageData.roleName = res.data.bind_data.role_name
    pageData.bindPopupState = false
    pageData.isBind = true
    try {
      window.__updatePointUploadCookie(
        "role_id",
        res.data.bind_data.role_id
      )
      window.__updatePointUploadCookie(
        "role_name",
        res.data.bind_data.role_name
      )
      window.__updatePointUploadCookie(
        "server_id",
        res.data.bind_data.server_id
      )
    } catch (error) {}
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
}

watch(() => compData.copyTipsState, value => {
  if (value) {
    setTimeout(() => {
      compData.copyTipsState = false;
    }, 2000)
  }
});
      // 绑定弹窗的click事件
      const u_c_I48K21_event_F8M123= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_1OB822_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认绑定的click事件
      const u_c_2UDV40_event_QSVC19= async (e)=>{
        try {if (!pageData.serverItem || !pageData.serverItem.sid) {
  alert(getLangTxt("selectServer"))
  return
}
if (!pageData.roleIndex) {
  alert(getLangTxt("selectRole"))
  return
}
if (!canClickBindSubmit.value) return
canClickBindSubmit.value = false
await bindRole()
canClickBindSubmit.value = true} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_IXTY43_event_DMX517= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗的click事件
      const u_c_J40V44_event_F8M123= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗内容的click事件
      const u_c_G90Y45_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 查看的click事件
      const u_c_YZRB62_event_1JVM17= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 复制并前往的click事件
      const u_c_8QYO64_event_QX7K17= async (e,code)=>{
        try {try{
  await toClipboard(code);
}catch(e){}

window.open(pageData.exchangeLink,"_self")} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_GD8367_event_DMX517= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 提示语弹窗的click事件
      const u_c_JBXS68_event_TETB35= async (e)=>{
        try {pageData.tipsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_FLPV69_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_AMGH72_event_V0IC67= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_EVGO74_event_DMX517= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 查看奖励弹窗的click事件
      const u_c_DSXT75_event_TETB35= async (e)=>{
        try {pageData.seeGiftPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_HPWW76_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_BRQF87_event_DMX517= async (e)=>{
        try {pageData.seeGiftPopupState = false} catch (error) {console.log(error)}
      };
      // 道具领取成功弹窗的click事件
      const u_c_EHPW88_event_TETB35= async (e)=>{
        try {pageData.propsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_IOX689_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_6OXR96_event_YU9U68= async (e)=>{
        try {pageData.propsPopupState = false;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_EM2I99_event_DMX517= async (e)=>{
        try {pageData.propsPopupState = false} catch (error) {console.log(error)}
      };
      // 优惠券领取成功弹窗的click事件
      const u_c_5R8F100_event_TETB35= async (e)=>{
        try {pageData.quanPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_2BKH101_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_BTH6108_event_35V252= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_9BQD110_event_DMX517= async (e)=>{
        try {pageData.quanPopupState = false} catch (error) {console.log(error)}
      };
      // 序列号领取成功弹窗的click事件
      const u_c_2XPV111_event_TXZS38= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_DB6Y112_event_EKU139= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_XYF6118_event_QX7K17= async (e)=>{
        try {await toClipboard(pageData.curGiftName);
compData.copyTipsState = true;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_BSRV122_event_KBHJ41= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 前往兑换的click事件
      const u_c_F9TM123_event_YU9U68= async (e)=>{
        try {try{
  await toClipboard(pageData.curGiftName);
  compData.copyTipsState = true;
  await utils.sleep(1)
}catch(e){}

window.open(pageData.exchangeLink,"_self")} catch (error) {console.log(error)}
      };
      // 活动规则弹窗的click事件
      const u_c_GAB2125_event_TETB35= async (e)=>{
        try {pageData.infoPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_2FB6126_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_FFZT130_event_DMX517= async (e)=>{
        try {pageData.infoPopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.33rem;
height:6.83rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208388-93.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417497876-15.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.33rem;
height:9.81rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208341-98.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:3.04rem;
height:1.07rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417497762-67.jpeg);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.default{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.default{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.default{
.u_c_CQKU26.normal{
position:relative;

}
}.default{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_EBOH36.normal{
position:relative;

}
}.default{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.default{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.default{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.default{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.default{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_ZVJ350.normal{
position:relative;

}
}.default{
.u_c_8WD951.normal{
position:relative;

}
}.default{
.u_c_ZT6B53.normal{
position:relative;

}
}.default{
.u_c_CW1R55.normal{
position:relative;

}
}.default{
.u_c_6SM956.normal{
position:relative;

}
}.default{
.u_c_DMOQ57.normal{
position:relative;

}
}.default{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_JC4161.normal{
position:relative;

}
}.default{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.default{
.u_c_8QYO64.normal{
position:relative;

}
}.default{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.default{
.u_c_JBXS68.normal{
position:relative;

}
}.default{
.u_c_FLPV69.normal{
position:relative;

}
}.default{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.default{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.default{
.u_c_DSXT75.normal{
position:relative;

}
}.default{
.u_c_HPWW76.normal{
position:relative;

}
}.default{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.default{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.default{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.default{
.u_c_98EV81.normal{
position:relative;

}
}.default{
.u_c_DJ6M82.normal{
position:relative;

}
}.default{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.default{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.default{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.default{
.u_c_08ZY86.normal{
position:relative;

}
}.default{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.default{
.u_c_EHPW88.normal{
position:relative;

}
}.default{
.u_c_IOX689.normal{
position:relative;

}
}.default{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.default{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.default{
.u_c_22F993.normal{
position:relative;

}
}.default{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.default{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.default{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.default{
.u_c_5R8F100.normal{
position:relative;

}
}.default{
.u_c_2BKH101.normal{
position:relative;

}
}.default{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.default{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.default{
.u_c_1MD4105.normal{
position:relative;

}
}.default{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.default{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.default{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_DB6Y112.normal{
position:relative;

}
}.default{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.default{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.default{
.u_c_2BKA116.normal{
position:relative;

}
}.default{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.default{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.default{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.default{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_GAB2125.normal{
position:relative;

}
}.default{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.default{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}.zh-TW{
.u_c_EPKV20.normal{
position:relative;
z-index:100;

}

.u_c_EPKV20.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-content-small{
width:9.33rem;
height:6.83rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208388-93.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .popup-close{
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417497876-15.png);

}

.u_c_EPKV20.normal .popup-title{
font-size:0.48rem;
text-align:center;

}

.u_c_EPKV20.normal .popup-content-big{
width:9.33rem;
height:9.81rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208341-98.jpeg);
position:relative;
box-sizing:border-box;
padding:0.27rem 0.53rem;

}

.u_c_EPKV20.normal .sure{
display:flex;
width:3.04rem;
height:1.07rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/07/1722417497762-67.jpeg);
font-size:0.32rem;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_EPKV20.normal .popup-title-color{
color:#f4d2aa;

}

.u_c_EPKV20.normal .txt-size{
font-size:0.29rem;

}

.u_c_EPKV20.normal .txt-color{
color:#ffffff;

}

.u_c_EPKV20.normal .tips-color{
color:red;

}

.u_c_EPKV20.normal .border-color{
border:1px solid;
border-color:#F0CAA1;

}
}.zh-TW{
.u_c_I48K21.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_1OB822.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_4UE223.normal{
position:relative;
margin-top:1.40rem;

}
}.zh-TW{
.u_c_YUHB25.normal{
position:relative;
margin:auto;
margin-top:0.33rem;
text-align:center;
font-size:0;

}

.u_c_YUHB25.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_YUHB25.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;
color:#333;

}
}.zh-TW{
.u_c_CQKU26.normal{
position:relative;

}
}.zh-TW{
.u_c_GZMD27.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_8QQF28.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_ZIPQ30.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_02BK31.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_D17Q33.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_1T3P34.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_EBOH36.normal{
position:relative;

}
}.zh-TW{
.u_c_46K737.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_ZXZE38.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_2UDV40.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_EELD42.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.zh-TW{
.u_c_IXTY43.normal{
position:absolute;
top:0.69rem;
right:0.57rem;

}
}.zh-TW{
.u_c_J40V44.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_G90Y45.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_F3OS46.normal{
position:relative;
margin-top:1.44rem;

}
}.zh-TW{
.u_c_JBXQ48.normal{
position:relative;
height:6.87rem;
overflow-y:auto;
margin-top:0.15rem;

}
}.zh-TW{
.u_c_J9YU49.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_J9YU49.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_J9YU49.normal .th:last-child{
border-right:none;

}

.u_c_J9YU49.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_J9YU49.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_J9YU49.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_ZVJ350.normal{
position:relative;

}
}.zh-TW{
.u_c_8WD951.normal{
position:relative;

}
}.zh-TW{
.u_c_ZT6B53.normal{
position:relative;

}
}.zh-TW{
.u_c_CW1R55.normal{
position:relative;

}
}.zh-TW{
.u_c_6SM956.normal{
position:relative;

}
}.zh-TW{
.u_c_DMOQ57.normal{
position:relative;

}
}.zh-TW{
.u_c_DOWL59.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_7W3S60.normal{
position:relative;
white-space:pre-line;

}
}.zh-TW{
.u_c_JC4161.normal{
position:relative;

}
}.zh-TW{
.u_c_YZRB62.normal{
position:relative;
color:#ffac00;

}
}.zh-TW{
.u_c_8QYO64.normal{
position:relative;

}
}.zh-TW{
.u_c_YHLR66.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_GD8367.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-TW{
.u_c_JBXS68.normal{
position:relative;

}
}.zh-TW{
.u_c_FLPV69.normal{
position:relative;

}
}.zh-TW{
.u_c_8UMN70.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:2.61rem;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_AMGH72.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_EVGO74.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.zh-TW{
.u_c_DSXT75.normal{
position:relative;

}
}.zh-TW{
.u_c_HPWW76.normal{
position:relative;

}
}.zh-TW{
.u_c_ZKSL77.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.57rem;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_Z9SF79.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:4.21rem;
white-space:pre-line;

}
}.zh-TW{
.u_c_HBYF80.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.zh-TW{
.u_c_98EV81.normal{
position:relative;

}
}.zh-TW{
.u_c_DJ6M82.normal{
position:relative;

}
}.zh-TW{
.u_c_4ON683.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.zh-TW{
.u_c_5A9Y84.normal{
position:relative;
width:60%;

}
}.zh-TW{
.u_c_ISS685.normal{
position:relative;
width:100%;
line-height:150%;

}
}.zh-TW{
.u_c_08ZY86.normal{
position:relative;

}
}.zh-TW{
.u_c_BRQF87.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.zh-TW{
.u_c_EHPW88.normal{
position:relative;

}
}.zh-TW{
.u_c_IOX689.normal{
position:relative;

}
}.zh-TW{
.u_c_83CB90.normal{
position:relative;
margin-top:1.63rem;

}
}.zh-TW{
.u_c_0RUO92.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_22F993.normal{
position:relative;

}
}.zh-TW{
.u_c_YMZE94.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_22A595.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_6OXR96.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_IGPN98.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.zh-TW{
.u_c_EM2I99.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.zh-TW{
.u_c_5R8F100.normal{
position:relative;

}
}.zh-TW{
.u_c_2BKH101.normal{
position:relative;

}
}.zh-TW{
.u_c_E8TO102.normal{
position:relative;
margin-top:1.65rem;

}
}.zh-TW{
.u_c_C672104.normal{
position:relative;
height:4.55rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_1MD4105.normal{
position:relative;

}
}.zh-TW{
.u_c_H54V106.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_3NFV107.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_BTH6108.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_9BQD110.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.zh-TW{
.u_c_2XPV111.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_DB6Y112.normal{
position:relative;

}
}.zh-TW{
.u_c_7UKR113.normal{
position:relative;
margin-top:1.63rem;

}
}.zh-TW{
.u_c_Z6D0115.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.28rem;

}
}.zh-TW{
.u_c_2BKA116.normal{
position:relative;

}
}.zh-TW{
.u_c_XYF6118.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.zh-TW{
.u_c_B9NJ120.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_B9NJ120.normal.hide{
opacity:0;

}
}.zh-TW{
.u_c_BSRV122.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.zh-TW{
.u_c_F9TM123.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_GAB2125.normal{
position:relative;

}
}.zh-TW{
.u_c_2FB6126.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_37SC127.normal{
position:relative;
margin-top:1.51rem;

}
}.zh-TW{
.u_c_1KND129.normal{
position:relative;
box-sizing:border-box;
height:6.77rem;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.35rem;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_FFZT130.normal{
position:absolute;
top:0.68rem;
right:0.57rem;

}
}
</style>
